import { CartItem } from "./cart-item";

export class ShoppingCart {
  items: CartItem[] = new Array<CartItem>();
  CartTotal = 0;
  CartMonthlyTotal = 0;
  TotalItems: number;
}
